window.addEventListener('load', () => {
  const menu = document.querySelector('.js-konintodoke-menu')
  if (!menu) return

  const toggles = document.querySelectorAll('.js-konintodoke-menu-toggle')
  const closes = document.querySelectorAll('.js-konintodoke-menu-close')
  const links = menu.querySelectorAll('a')
  const header = document.querySelector('.konintodoke-header')
  const panel = menu.querySelector('.konintodoke-menu__panel')

  // html に overflow-x: hidden がある構成では body の overflow: hidden が
  // ビューポートへ伝播しないため、body を position: fixed で固定して
  // 背景スクロールをロックする(iOS Safari/Chrome でも有効な方式)
  let scrollYWhenOpened = 0

  // モーダル表示中は背面コンテンツを inert 化し、Tab 移動・クリックの対象から外す。
  // ヘッダーとメニュー自身は対象外だが、ヘッダー内のロゴリンクは個別に inert 化し、
  // メニュー表示中に操作できるのはトグルボタンとメニュー内だけになるようにする
  const brand = header ? header.querySelector('.konintodoke-header__brand') : null
  const inertTargets = () => {
    const targets = Array.from(document.body.children).filter(el => (
      el !== header && el !== menu && !['SCRIPT', 'NOSCRIPT'].includes(el.tagName)
    ))
    if (brand) targets.push(brand)
    return targets
  }

  // 閉じたときにフォーカスを戻す先(開いたときに操作した要素)
  let openerElement = null

  // 開閉時のフォーカス移動(open/close内のfocus())は、キーボード利用者が迷子に
  // ならないために必要だが、JSからのfocus()はブラウザに「キーボード操作」と
  // みなされるため、タップで開閉した人にもフォーカスリングが見えてしまう。
  // 直前の操作がポインタだったかを覚えておき、その場合だけリングを抑制する
  let usedPointer = false
  const applyFocusRingVisibility = () => {
    document.body.classList.toggle('-konintodoke-hide-focus-ring', usedPointer)
  }
  document.addEventListener('pointerdown', () => { usedPointer = true }, true)
  // キー操作に切り替わった時点で抑制を解除する。ここで解除しないと、
  // タップで開いた後にTabで移動しようとした人にリングが出ないままになる
  document.addEventListener('keydown', () => {
    usedPointer = false
    applyFocusRingVisibility()
  }, true)

  // ヘッダーの実高をCSS変数へ同期する。メニューの表示位置に加えて、
  // カテゴリ詳細のsticky領域など「ヘッダーの下に張り付く」要素も参照するため、
  // メニュー開閉時だけでなくロード時・リサイズ時にも常に設定しておく
  const syncHeaderHeight = () => {
    if (header) {
      document.documentElement.style.setProperty('--konintodoke-header-height', `${header.offsetHeight}px`)
    }
  }
  syncHeaderHeight()
  window.addEventListener('resize', syncHeaderHeight)

  const open = () => {
    syncHeaderHeight()
    menu.classList.add('-is-open')
    menu.setAttribute('aria-hidden', 'false')
    scrollYWhenOpened = window.scrollY
    document.body.classList.add('-konintodoke-menu-open')
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollYWhenOpened}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.width = '100%'
    openerElement = document.activeElement
    inertTargets().forEach(el => el.setAttribute('inert', ''))
    applyFocusRingVisibility()
    const firstFocusable = menu.querySelector('a[href], button:not([disabled])')
    if (firstFocusable) firstFocusable.focus()
    toggles.forEach(el => {
      el.setAttribute('aria-expanded', 'true')
      el.setAttribute('aria-label', '目次を閉じる')
    })
  }

  const close = () => {
    menu.classList.remove('-is-open')
    menu.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('-konintodoke-menu-open')
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.width = ''
    inertTargets().forEach(el => el.removeAttribute('inert'))
    window.scrollTo(0, scrollYWhenOpened)
    applyFocusRingVisibility()
    // フォーカスを開いたときの要素(通常はトグルボタン)へ戻す
    if (openerElement && document.contains(openerElement) && openerElement !== document.body) {
      openerElement.focus()
    } else if (toggles[0]) {
      toggles[0].focus()
    }
    openerElement = null
    toggles.forEach(el => {
      el.setAttribute('aria-expanded', 'false')
      el.setAttribute('aria-label', '目次を開く')
    })
  }

  toggles.forEach(el => el.addEventListener('click', () => {
    menu.classList.contains('-is-open') ? close() : open()
  }))

  closes.forEach(el => el.addEventListener('click', close))
  if (panel) {
    panel.addEventListener('click', e => {
      if (e.target === panel) close()
    })
  }
  links.forEach(el => el.addEventListener('click', close))

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && menu.classList.contains('-is-open')) close()
  })
})
